"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPropertyEditorRoute = getPropertyEditorRoute;
exports.getPersonaEditorRoute = getPersonaEditorRoute;
exports.getRoutePrefix = getRoutePrefix;
exports.getRouteWithoutPrefix = getRouteWithoutPrefix;
exports.isAppRoute = isAppRoute;
exports.getDashboardRoute = getDashboardRoute;
exports.getDynoEditorRoute = getDynoEditorRoute;
exports.getDynoListRoute = getDynoListRoute;
exports.getDynoDetailsRoute = getDynoDetailsRoute;
exports.getDynoDetailsByGuidRoute = getDynoDetailsByGuidRoute;
exports.getSettingsRoute = getSettingsRoute;
exports.getEmailContentSettingsRoute = getEmailContentSettingsRoute;
exports.getEmbedCodeRoute = getEmbedCodeRoute;
exports.getWorkflowsRoute = getWorkflowsRoute;

var _underscore = require("underscore");

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var _DynoEditor = require("lead-flows-ui/constants/DynoEditor");

var DEFAULT_EDITOR_STEP = (0, _underscore.first)(Object.values(_DynoEditor.STEPS || {}));

function getContactsRoutePrefix(path) {
  var portalId = _hubspot.default.get();

  return "/contacts/" + portalId + "/" + path;
}

function getPropertyEditorRoute(name) {
  return getContactsRoutePrefix("settings/property/" + name + "/");
}

function getPersonaEditorRoute() {
  return getContactsRoutePrefix('/personas');
}

function getRoutePrefix() {
  return "/lead-flows/" + _hubspot.default.get();
} // `/marketing/123/flows` => `flows`


function getRouteWithoutPrefix() {
  var pathComponents = window.location.pathname.split('/');
  return pathComponents.slice(3).join('/');
}

function isAppRoute(url) {
  return url.indexOf(getRoutePrefix()) !== -1;
}

function getDashboardRoute() {
  return getRoutePrefix();
}

function getDynoEditorRoute(dynoId) {
  var step = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_EDITOR_STEP;
  var redirectUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return redirectUrl ? getRoutePrefix() + "/edit/" + dynoId + "/" + step + "?redirectUrl=" + encodeURIComponent(redirectUrl) : getRoutePrefix() + "/edit/" + dynoId + "/" + step;
}

function getDynoListRoute(pageNumber) {
  return "" + getRoutePrefix() + (pageNumber ? "/page/" + pageNumber : '');
}

function getDynoDetailsRoute(dynoId) {
  return getRoutePrefix() + "/details/" + dynoId;
}

function getDynoDetailsByGuidRoute(formGuid) {
  return getRoutePrefix() + "/from-form-guid/" + formGuid;
}

function getSettingsRoute() {
  return "/settings/" + _hubspot.default.get() + "/marketing/email-service-provider";
}

function getEmailContentSettingsRoute() {
  return "/content/" + _hubspot.default.get() + "/settings/email";
}

function getEmbedCodeRoute() {
  return "/settings/" + _hubspot.default.get() + "/analytics-and-tracking/tracking";
}

function getWorkflowsRoute() {
  return "/workflows/" + _hubspot.default.get();
}